import React from "react"
import "./TicketRow.scss"

export function PassCodeRow(props) {

    const {id, passCode, onInputPassCode} = props

    function changePassCode(event) {
        const element = event.target
        const newPassCodeValue = element.value
        onInputPassCode(newPassCodeValue)
    }
    return (
        
        <tr className="TicketRow passcode" data-id={id}>
            <td>
                <label forhtml="passcodeInput">Code du pass : </label>
                <input type="text" id="passcodeInput" name="passcode" value={passCode} onInput={changePassCode}/>
            </td>
            <td></td>
            <td></td>
            <td></td>
            <td className="TicketRow-action"></td>
            <td></td>
        </tr>
    )
}